import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OficinaService {
  private data = null;
	private url = environment.serviceApi;
 	constructor(public http: Http) { }

  	getOficinas(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/oficina' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getOficina(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/oficina/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaOficina(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/oficina', {
				oficina_nome: data.oficina_nome,
				oficina_contato: data.oficina_contato,
				oficina_cnpj: data.oficina_cnpj,
				oficina_endereco: data.oficina_endereco,
				oficina_endereco_numero: data.oficina_endereco_numero,
				oficina_cep: data.oficina_cep,
				oficina_municipio: data.oficina_municipio,
				oficina_bairro: data.oficina_bairro,
				oficina_uf: data.oficina_uf
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaOficina(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/oficina/' + data.oficina_id, {
        		oficina_nome: data.oficina_nome,
        		oficina_contato: data.oficina_contato,
				oficina_cnpj: data.oficina_cnpj,
				oficina_endereco: data.oficina_endereco,
				oficina_endereco_numero: data.oficina_endereco_numero,
				oficina_cep: data.oficina_cep,
				oficina_municipio: data.oficina_municipio,
				oficina_bairro: data.oficina_bairro,
				oficina_uf: data.oficina_uf
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaOficina(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/oficina/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
